(()=>{
  if(window.__amsClients){window.__amsClients();return;}
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const SHAPE=[[-.1,.6],[.1,.26],[.28,.3],[.44,.68],[.6,.82],[.76,.4],[.92,.22],[1.1,.5]];
  function curve(p){let d=`M${p[0][0].toFixed(1)},${p[0][1].toFixed(1)}`;for(let i=0;i<p.length-1;i++){const a=p[i-1]||p[i],b=p[i],c=p[i+1],e=p[i+2]||c;d+=`C${(b[0]+(c[0]-a[0])/6).toFixed(1)},${(b[1]+(c[1]-a[1])/6).toFixed(1)} ${(c[0]-(e[0]-b[0])/6).toFixed(1)},${(c[1]-(e[1]-b[1])/6).toFixed(1)} ${c[0].toFixed(1)},${c[1].toFixed(1)}`;}return d;}
  function shuffle(a){for(let i=a.length-1;i>0;i--){const j=Math.random()*(i+1)|0;[a[i],a[j]]=[a[j],a[i]];}return a;}
  /* ordine casuale, con i clienti che hanno un progetto distribuiti in modo regolare lungo il nastro */
  function mix(chips){
    const withCase=shuffle(chips.filter(c=>c.classList.contains('has-case')));
    const others=shuffle(chips.filter(c=>!c.classList.contains('has-case')));
    if(!withCase.length)return others;
    const step=others.length/withCase.length,out=[];let used=0,acc=0;
    withCase.forEach(c=>{out.push(c);acc+=step;while(used<Math.round(acc)&&used<others.length)out.push(others[used++]);});
    while(used<others.length)out.push(others[used++]);
    return out;
  }
  function ribbon(root){
    const stage=root.querySelector('.ams-ribbon-stage'),svg=stage&&stage.querySelector('svg'),path=svg&&svg.querySelector('path');
    const list=stage&&stage.querySelector('.ams-ribbon-list');
    let chips=stage?[...stage.querySelectorAll('.ams-chip')]:[];
    if(!path||!chips.length)return;
    if(root.dataset.order!=='fixed'){chips=mix(chips);chips.forEach(c=>list.appendChild(c));}
    root.classList.add('is-live');
    let W=0,H=0,L=1,T=1,gap=1,margin=0,offset=0,speed=reduce.matches?0:1,target=speed,frame=0,last=0,visible=false,hover=false,drag=null,suppress=false,paused=false,pointerUsed=false;
    const base=()=>innerWidth<=760?32:46;
    function build(){
      W=stage.clientWidth;H=stage.clientHeight;if(!W||!H)return;
      svg.setAttribute('viewBox',`0 0 ${W} ${H}`);
      path.setAttribute('d',curve(SHAPE.map(([x,y])=>[x*W,y*H])));
      L=path.getTotalLength();
      const card=chips[0].offsetWidth||156;margin=card;
      T=Math.max(L+margin*2,chips.length*card*1.4);gap=T/chips.length;place();
    }
    function place(){
      chips.forEach((c,i)=>{
        const s=((offset+i*gap)%T+T)%T-margin,on=s>=-margin*.5&&s<=L+margin*.5;
        c.classList.toggle('is-off',!(s>=0&&s<=L));
        if(!on)return;
        const k=Math.max(0,Math.min(L,s)),p=path.getPointAtLength(k),q=path.getPointAtLength(Math.min(L,k+2)),r=path.getPointAtLength(Math.max(0,k-2));
        const ang=Math.atan2(q.y-r.y,q.x-r.x)*180/Math.PI;
        c.style.transform=`translate(${p.x.toFixed(1)}px,${p.y.toFixed(1)}px) translate(-50%,-50%) rotate(${(ang*.3).toFixed(2)}deg)`;
      });
    }
    function tick(now){
      frame=0;const dt=Math.min((now-last)/1000||.016,.05);last=now;
      speed+=(target-speed)*Math.min(1,dt*3);
      if(!drag)offset+=speed*base()*dt;
      place();
      if(visible&&!document.hidden&&(Math.abs(speed)>.002||Math.abs(target)>.002))frame=requestAnimationFrame(tick);
    }
    function wake(){if(!frame&&visible&&!document.hidden){last=performance.now();frame=requestAnimationFrame(tick);}}
    function aim(){target=reduce.matches||drag||hover||paused?0:1;wake();}
    root.__amsPause=v=>{paused=v;aim();};
    chips.forEach((c,i)=>{
      c.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;aim();}});
      c.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hover=false;aim();}});
      c.addEventListener('focusin',()=>{hover=true;if(!pointerUsed){offset=L/2+margin-i*gap;place();}aim();});
      c.addEventListener('focusout',()=>{hover=false;aim();});
    });
    stage.addEventListener('pointerdown',e=>{
      pointerUsed=true;setTimeout(()=>{pointerUsed=false;},600);
      if(e.button)return;drag={x:e.clientX,off:offset,moved:false,id:e.pointerId};aim();
    });
    stage.addEventListener('pointermove',e=>{
      if(!drag||e.pointerId!==drag.id)return;const dx=e.clientX-drag.x;
      if(!drag.moved&&Math.abs(dx)>6){drag.moved=true;stage.classList.add('is-dragging');try{stage.setPointerCapture(e.pointerId);}catch(_){}}
      if(drag.moved){offset=drag.off+dx;place();}
    });
    const end=()=>{if(!drag)return;suppress=drag.moved;drag=null;stage.classList.remove('is-dragging');aim();setTimeout(()=>{suppress=false;},0);};
    stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
    stage.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopPropagation();}},true);
    stage.addEventListener('dragstart',e=>e.preventDefault());
    new ResizeObserver(build).observe(stage);
    new IntersectionObserver(es=>{visible=es[0].isIntersecting;wake();},{rootMargin:'60px'}).observe(stage);
    document.addEventListener('visibilitychange',wake);
    reduce.addEventListener('change',aim);
    build();
  }
  function dialog(root){
    const open=root.querySelector('[data-clients-open]'),dlg=root.querySelector('.ams-clients-dialog');
    if(!open||!dlg||typeof dlg.showModal!=='function')return;
    const float=dlg.querySelector('.ams-cd-float'),img=float&&float.querySelector('img');
    open.addEventListener('click',()=>{dlg.showModal();dlg.scrollTop=0;root.__amsPause&&root.__amsPause(true);});
    dlg.querySelector('[data-clients-close]')?.addEventListener('click',()=>dlg.close());
    dlg.addEventListener('click',e=>{if(e.target===dlg)dlg.close();});
    dlg.addEventListener('close',()=>{root.__amsPause&&root.__amsPause(false);if(float)float.classList.remove('is-on');open.focus();});
    if(!float)return;
    dlg.querySelectorAll('.ams-cd-name[data-logo]').forEach(n=>{
      n.addEventListener('pointerenter',e=>{if(e.pointerType!=='mouse')return;if(img.getAttribute('src')!==n.dataset.logo)img.src=n.dataset.logo;float.classList.toggle('is-light',n.classList.contains('is-light'));float.classList.add('is-on');});
      n.addEventListener('pointerleave',()=>float.classList.remove('is-on'));
    });
    dlg.addEventListener('pointermove',e=>{
      if(e.pointerType!=='mouse')return;
      const w=float.offsetWidth,h=float.offsetHeight;
      let x=e.clientX+26,y=e.clientY-h-18;
      if(x+w>innerWidth-12)x=e.clientX-w-26;
      if(y<12)y=e.clientY+26;
      float.style.transform=`translate(${x}px,${y}px) rotate(-4deg)`;
    },{passive:true});
  }
  function run(){
    document.querySelectorAll('[data-ams-clients]:not([data-clients-ready])').forEach(el=>{
      el.dataset.clientsReady='1';
      if(el.hasAttribute('data-ams-ribbon'))ribbon(el);
      dialog(el);
      if(reduce.matches||!('IntersectionObserver' in window))return;
      el.classList.add('is-ready');
      const io=new IntersectionObserver(es=>{if(es.some(e=>e.isIntersecting)){el.classList.add('is-in');io.disconnect();}},{threshold:.15});
      io.observe(el);
    });
  }
  window.__amsClients=run;
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  document.addEventListener('shopify:section:load',run);
})();